var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoltIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5129 1.32913C12.7639 1.46908 12.8871 1.76219 12.8115 2.03947L11.1518 8.12502H17.2085C17.4574 8.12502 17.6825 8.27267 17.7817 8.50093C17.8809 8.72918 17.8352 8.99453 17.6654 9.17647L8.91542 18.5515C8.71932 18.7616 8.4052 18.8109 8.15417 18.6709C7.90314 18.531 7.77991 18.2379 7.85553 17.9606L9.51523 11.875H3.45851C3.20964 11.875 2.98448 11.7274 2.88529 11.4991C2.7861 11.2709 2.83179 11.0055 3.0016 10.8236L11.7516 1.44857C11.9477 1.23846 12.2618 1.18917 12.5129 1.32913Z",
    fill: "#1D31A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltIcon);
export default __webpack_public_path__ + "static/media/boltIcon.54acc6e818d81c11eb46a0121021efd3.svg";
export { ForwardRef as ReactComponent };